














import {Drag} from "vue-drag-drop";
import {Vue, Component, Prop} from "vue-property-decorator";
import DynamicComponents from "./DynamicComponents.vue";
import {SDynamicComponent} from "@/components/dto/SDynamicComponent";
import {SourceGenerator} from "@/components/utils/SourceGenerator";
import SourceTemplate from "@/components/SourceTemplate.vue";
import {SComponentsGroup} from "@/components/dto/SComponentsGroup";

@Component({
    components: {SourceTemplate, DynamicComponents,Drag}
})
export default class ComponentSource extends Vue {
    @Prop() components!: SDynamicComponent[];
    @Prop() basicComponent!: SComponentsGroup[];
    @Prop() data!: any;

    get generateSource(){
        let it = SourceGenerator.generateTemplate(this.components);
        return it;
    }
    handle_function_call(e: any, param: any) {
        this.$emit('callfunction', e, param);
    }

}
